import { render, staticRenderFns } from "./npform2.vue?vue&type=template&id=4c36b348"
import script from "./npform2.vue?vue&type=script&lang=js"
export * from "./npform2.vue?vue&type=script&lang=js"
import style0 from "./npform2.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports